var map = {
	"./main_logo_ace.png": "521d",
	"./main_logo_kiturami.png": "7347",
	"./main_logo_kogene.png": "70f5",
	"./main_logo_pantech.png": "717c",
	"./main_logo_saerom.png": "2061"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c848";